import  { useEffect, useState } from "react";

import { useLocation } from "react-router-dom";
import { connect } from "react-redux";

import FileSaver from "file-saver";
import toast, { Toaster } from "react-hot-toast";

import {
  BulkUploadError,
  BulkUploadSuccess,
  DownloadIcon,
  ReloadIcon
} from "../../components/Icon";
import DraggableUpload from "../../components/commons/Upload/DraggableUpload";
import {
  CommonHeader,
  ErrorSuccessModal,
  Loader,
} from "../../components/commons";
import { resetSession } from "../../redux/auth";

import { RootState } from "../../redux/rootReducers";
import {
  resetBulkUpload,
  resetFixedAssetRegisterError,
  resetFixedAssetRegisterMessage,
  resetFixedAssetRegisterSuccess,
} from "../../redux/fixedAsset";
import { fixedAssetBulkUploadDataAction } from "../../redux/fixedAsset/actions";
import BulkUploadHistoryModal from "../../components/InvoiceGeneration/BulkUploadHistory/BulkUploadHistoryModal";
import { GetBulkUploadHistoryPayloadType } from "../../commonTypes/invoiceGenerationTypes";
import { getBulkUploadHistoryAction, resetBulkUploadHistoryCount, resetBulkUploadHistoryData } from "../../redux/invoiceGeneration";
import { BulkUploadHistoryDataType } from "../../redux/invoiceGeneration/invoiceGenrationTypes";
import { useMenuCheck } from "../../customHooks/useMenuCheck";


const blobBaseUrl = process.env.REACT_APP_BLOB_BASE_URL;
const blobToken = process.env.REACT_APP_BLOB_TOEKN;

interface Props {
  history: any;
  token: string | null;
  bulkUploadData: any | null;
  fetching: boolean;
  success: number | null;
  error: string | null;
  statusCode: number | null;
  dispatchResetSession: () => void;
  dispatchResetBulkUploadData: Function;
  message: null | string;
  bulkUploadCount:string;
  dispatchFixedAssetBulkUploadData: (data: any) => void;
  dispatchResetFixedAssetRegisterSuccess: () => void;
  dispatchResetFixedAssetRegisterError: () => void;
  dispatchResetFixedAssetRegisterMessage: () => void;
  bulkUploadHistoryData:BulkUploadHistoryDataType[] | [];
  dispatchResetBulkUploadHistoryData:()=>void;
  dispatchResetBulkUploadHistoryCount:()=>void;
  dispatchGetBulkUploadHistoryData:(data:GetBulkUploadHistoryPayloadType)=>void;
}

const OTHER_COLUMN_NAMES: any[] = [
  "Document Number",
  "Asset Id",
  "Department",
  "Asset Description",
  "Location",
  "Sub-location",
  "Depreciation Method",
  "Asset Category",
  "Asset Sub-category",
  "Date of Put to Use",
  "General Ledger",
  "GL Code",
  "Manufacturer",
  "Condition",
  "Sales Item Name",
  "Sales Customer Name",
  "Sales Invoice Number",
  "Sales Invoice Date",
  "Sales Amount",
  "Purchase Item Name",
  "Purchase Supplier Name",
  "Purchase Invoice Number",
  "Purchase Invoice Date",
  "Purchase Amount",
  "Quantity",
];

const FixedAssetBulkUpload = ({
  history,
  token,
  bulkUploadData,
  success,
  error,
  statusCode,
  fetching,
  bulkUploadCount,
  dispatchResetSession,
  dispatchResetBulkUploadData,
  //   dispatchResetInvoicingSuccess,
  message,
  dispatchFixedAssetBulkUploadData,
  dispatchResetFixedAssetRegisterSuccess,
  dispatchResetFixedAssetRegisterError,
  dispatchResetFixedAssetRegisterMessage,
  bulkUploadHistoryData,
  dispatchResetBulkUploadHistoryData,
  dispatchGetBulkUploadHistoryData,
  dispatchResetBulkUploadHistoryCount
}: Props) => {
  const search = useLocation().search;

  let type = new URLSearchParams(search).get("type") || "";
  let ComapanyName = new URLSearchParams(search).get("company") || "";
  const url = window.location.pathname.split("/");
  const client_code = Number(url[url.length - 1]);

  const [fileData, setFileData] = useState<any>("");
  const [fileNames, setFileNames] = useState([]);
  const findingRoute = useLocation().pathname.split("/");
  const [isBulkHistory,setIsBulkHistory]=useState(false);
  const [historyData,setHistoryData]=useState<BulkUploadHistoryDataType[] | []>([]);
  const [isFarBulkUploadHistory,setIsFarBulkUploadHistory]=useMenuCheck()
  const [offset,setOffset]=useState(0);
  const [limit,setLimit]=useState(20);
  const routeName = findingRoute[2];
  if (type === "") {
    type = "othersgeneration";
  }

  useEffect(() => {
    // dispatchResetInvoicingSuccess();
    // dispatchResetInvoicingError();
    setIsFarBulkUploadHistory("Fixed Asset Register Bulk Upload History","menu")
    dispatchResetBulkUploadData();
    dispatchResetFixedAssetRegisterSuccess();
    dispatchResetFixedAssetRegisterError();
    dispatchResetFixedAssetRegisterMessage();
    dispatchResetBulkUploadHistoryCount()
    dispatchResetBulkUploadHistoryData()
  }, []);

  useEffect(()=>{
    if(token && offset>0 && offset<+bulkUploadCount){
      let finalData={
        clientCode:client_code,
        token,
        type:"fixed_asset",
        limit,
        offset
      }
      dispatchGetBulkUploadHistoryData(finalData)
    }
  },[offset])


  useEffect(() => {
    if (bulkUploadHistoryData?.length === 0) {
      setHistoryData(bulkUploadHistoryData);
    }
    if (offset > 0) {
      setHistoryData((prv: any) => [...prv, ...bulkUploadHistoryData]);
    } else {
      setHistoryData(bulkUploadHistoryData);
    }
  }, [bulkUploadHistoryData]);

  const handleViewHistory=()=>{
    dispatchResetBulkUploadData();
    toast.dismiss()
    if(token){
      let finalData={
        clientCode:client_code,
        token,
        type:"fixed_asset",
        limit,
        offset
      }
      dispatchGetBulkUploadHistoryData(finalData)
    }
    setIsBulkHistory((prev:boolean)=>!prev)
  }

  const downloadTemplate = () => {
    let headList: string[] = [];

    OTHER_COLUMN_NAMES.map((item: any) => {
      headList.push(item);
    });
    let csvData = headList.toString();
    var blob = new Blob([csvData], {
      type: "text/csv;charset=utf-8;",
    });

    FileSaver.saveAs(blob, "template.csv");
  };
  const handleUpload = (file: any) => {
    setFileData(file);
  };
  const startBulkProcess = () => {
    const params = {
      client_code,
      company_name: ComapanyName,
      fileData,
      token,
    };
    dispatchFixedAssetBulkUploadData(params);
  };

  const toogleBulkHistoryModal=()=>{
    setOffset(0)
    setHistoryData([])
    dispatchResetBulkUploadHistoryCount()
    dispatchResetBulkUploadHistoryData()
    setIsBulkHistory((prev:boolean)=>!prev)
  }

  const handleErrorModal = () => {
    if ((bulkUploadData && bulkUploadData?.success === 0) || success === 0) {
      if (
        (bulkUploadData && bulkUploadData?.status_code === 401) ||
        statusCode === 401
      ) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message={error}
            buttonText="Logout"
            onPress={() => {
              dispatchResetSession();
              dispatchResetFixedAssetRegisterError();
            }}
            statusCode={statusCode}
          />
        );
      } else if (
        (bulkUploadData && bulkUploadData?.status_code === 204) ||
        (bulkUploadData && bulkUploadData?.status_code === 500) ||
        error
      ) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!bulkUploadData?.success}
            title="Error"
            message={
              routeName === "bulk-upload" && bulkUploadData.status_code === 500
                ? "Columns are missing"
                : bulkUploadData?.message || error || "something went wrong!"
            }
            buttonText="OK"
            onPress={() => {
              dispatchResetBulkUploadData();
              setFileNames([]);
              dispatchResetFixedAssetRegisterSuccess();
              dispatchResetFixedAssetRegisterError();
              dispatchResetFixedAssetRegisterMessage();
            }}
          />
        );
      }
    }

    if (
      bulkUploadData?.success === 1 &&
      bulkUploadData &&
      bulkUploadData?.message
    ) {
      if (bulkUploadData && bulkUploadData?.error_rows_count === 0) {
        return (
          <ErrorSuccessModal
            type="success"
            isOpen={bulkUploadData?.success === 1}
            title="Success"
            message={
              bulkUploadData?.message || "Document Uploaded Successfully!"
            }
            buttonText="OK"
            onPress={() => {
              dispatchResetBulkUploadData();
              setFileNames([]);
              history.goBack();
              dispatchResetFixedAssetRegisterSuccess();
              dispatchResetFixedAssetRegisterError();
              dispatchResetFixedAssetRegisterMessage();
            }}
            statusCode={bulkUploadData?.status_code || statusCode}
          />
        );
      } else {
        toast.success(bulkUploadData?.message);
      }
    }
    return false;
  };
  const renderReUpload = () => {
    const {
      total_unique_row,
      total_inserted_rows,
      error_rows_count,
      error_file,
    } = bulkUploadData;
    return (
      <div className="dropzone drop-area" style={{ cursor: "default" }}>
        <h3>
          File Uploaded Successfully{" "}
          {error_rows_count === 0 ? "" : "But Found Errors"}
        </h3>
        <hr />

        <div className="details-card">
          <div>
            <h5>Overview</h5>
            <div className="overview-card">
              <div className="card inside-card">
                <BulkUploadSuccess />
                <h6>
                  <span className="counter-style">{total_inserted_rows}</span>{" "}
                  out of {total_unique_row}{" "}
                </h6>
                <h6 className="counter-sub-header mt-2">Successfull entries</h6>
              </div>
              <div className="card inside-card">
                <BulkUploadError />
                <h6>
                  <span className="counter-style">{error_rows_count}</span> out
                  of {total_unique_row}
                </h6>
                <h6 className="counter-sub-header mt-2">Total errors</h6>
              </div>
            </div>
          </div>

          <div>
            <h5>Please follow the steps below to fix it.</h5>
            <div>
              <div className="card card-text">
                {" "}
                <h5>
                  <span className="card-span">01</span>Please download the file.
                </h5>{" "}
              </div>
              <div className="card card-text">
                <h5>
                  <span className="card-span">02</span>Fix the errors
                </h5>{" "}
              </div>
              <div className="card card-text">
                <h5>
                  <span className="card-span">03</span>Re-upload the file.
                </h5>{" "}
              </div>
            </div>
          </div>
        </div>

        <div className="mt-5 mb-5 d-flex justify-content-end">
          <button
            className="ml-3 btn btn-primary"
            onClick={() => handleReUpload()}
          >
            Proceed to Re-Upload
          </button>
          <div className="ml-4">
            <a
              href={blobBaseUrl + error_file + "?" + blobToken}
              className="btn btn-outline-info "
            >
              Download Error CSV
            </a>
          </div>
        </div>
      </div>
    );
  };

  const handleReUpload = () => {
    dispatchResetBulkUploadData();
    setFileNames([]);
    setFileData("");
  };

  return (
    <div className="row">
      <div className="col-md-8 mb-3">
        <CommonHeader goBack title={`Bulk Upload - Fixed Asset`} />
      </div>
      <div className="col-12">
        <div className=" card p-3">
          <div className="d-flex justify-content-end" style={{gap:"10px"}}>
          <p className="text-right">
            <button className="btn btn-outline" onClick={downloadTemplate}>
              <DownloadIcon color="#DD4433" /> Download Blank Template
            </button>
          </p>

          {isFarBulkUploadHistory ? <p className="text-right">
            <button
              className="btn btn-outline"
              onClick={() => handleViewHistory()}
            >
              <ReloadIcon color="#DD4433"/>
               View History
            </button>
          </p>: null}
          </div>
         

          {bulkUploadData && bulkUploadData.error_file ? (
            renderReUpload()
          ) : (
            <DraggableUpload
              handleUpload={handleUpload}
              setFileNames={setFileNames}
              fileNames={fileNames}
              acceptedFileTypes=".csv,text/csv,application/csv"
            />
          )}
          {bulkUploadData && bulkUploadData.error_file ? null : (
            <div className="mt-3 d-flex">
              <button
                className="btn btn-primary btn-lg w-50 m-auto"
                onClick={startBulkProcess}
                disabled={
                  !fileData || !fileNames.length || fetching ? true : false
                }
              >
                Proceed
              </button>
            </div>
          )}
        </div>

        {
          isBulkHistory ?
          <div>
            <BulkUploadHistoryModal
             isBulkHistory={isBulkHistory}
             toogleBulkHistoryModal={toogleBulkHistoryModal}
             historyData={historyData}
             fetching={fetching}
             offset={offset}
             setOffset={setOffset}
             limit={limit}
            />
          </div> : null
         }

        {fetching ? <Loader /> : null}
        {handleErrorModal()}
        <Toaster />
      </div>
    </div>
  );
};

const mapStateToProps = (state: RootState) => ({
  bulkUploadData: state.fixedAssetRegister.bulkUploadData,
  token: state.auth.token,
  fetching: state.fixedAssetRegister.fetching,
  success: state.fixedAssetRegister.success,
  message: state.fixedAssetRegister.message,
  error: state.fixedAssetRegister.error,
  statusCode: state.fixedAssetRegister.statusCode,
  bulkUploadHistoryData: state.invoiceGeneration.bulkUploadHistoryData,
  bulkUploadCount: state.invoiceGeneration.bulkUploadCount
});

const mapDispatchToProps = (dispatch: any) => ({
  dispatchResetBulkUploadData: () => dispatch(resetBulkUpload()),
  dispatchResetSession: () => dispatch(resetSession()),
  dispatchFixedAssetBulkUploadData: (data: any) =>
    dispatch(fixedAssetBulkUploadDataAction(data)),
  dispatchResetFixedAssetRegisterSuccess: () =>
    dispatch(resetFixedAssetRegisterSuccess()),
  dispatchResetFixedAssetRegisterError: () =>
    dispatch(resetFixedAssetRegisterError()),
  dispatchResetFixedAssetRegisterMessage: () =>
    dispatch(resetFixedAssetRegisterMessage()),
  dispatchGetBulkUploadHistoryData : (data:GetBulkUploadHistoryPayloadType)=>
    dispatch(getBulkUploadHistoryAction(data)),
  dispatchResetBulkUploadHistoryData:()=>
    dispatch(resetBulkUploadHistoryData()),
  dispatchResetBulkUploadHistoryCount:()=>
    dispatch(resetBulkUploadHistoryCount())
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(FixedAssetBulkUpload);
